import { render, staticRenderFns } from "./mlxc.vue?vue&type=template&id=294a4d6c&scoped=true&"
import script from "./mlxc.vue?vue&type=script&lang=js&"
export * from "./mlxc.vue?vue&type=script&lang=js&"
import style0 from "./mlxc.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./mlxc.vue?vue&type=style&index=1&id=294a4d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294a4d6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('294a4d6c')) {
      api.createRecord('294a4d6c', component.options)
    } else {
      api.reload('294a4d6c', component.options)
    }
    module.hot.accept("./mlxc.vue?vue&type=template&id=294a4d6c&scoped=true&", function () {
      api.rerender('294a4d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/mlxc.vue"
export default component.exports